<template>
  <e-icon v-if="status == OrderStatus.Avoided" class="text-secondary" name="block" :size="size" />
  <e-icon v-else-if="status == OrderStatus.Confirmed" class="text-green" name="check" :size="size" />
  <e-icon v-else class="text-primary" name="sandClock" :size="size" />
</template>

<script setup lang="ts">
import { EIcon } from '@/core/components/ui';
import { OrderStatus } from '@/graphql/generated';

defineProps<{
  status: OrderStatus;
  size: string | number;
}>();
</script>
